module.exports = __webpack_public_path__ + "img/new.ce13b4e2.svg";